import { axios as $http } from 'cm'
import qs from 'qs'
import './style.scss'
import { getRunTime } from '../../../public-resource/libs/utils/index'
import Bridge from '../../../frontend-lib/lib/Bridge'

let HOST = getRunTime('//m.xinli001.com')
var uploadHOST = getRunTime('//www.xinli001.com')
let isMuseApp = window.$platform.isMuseApp
if (window.$platform.isYixinliApp || isMuseApp) {
  let myBrige = new Bridge()
  myBrige.call('setTitle', {
    title: '意见反馈'
  })
}
// toast组件
import Toast from '../../../public-resource/components/toast'

var isSubmiting = false // 防止二次点击提交反馈

var ifHasUploadModule = true // 标志是否有上传图片模块

// 隐藏显示上传图片入口
function controlImgIpt() {
  if (!ifHasUploadModule) return
  let uploadImg = document.querySelectorAll('.upload-img')
  if (uploadImg.length >= 4) {
    document.querySelector('.upload-entrance').style.display = 'none'
  } else {
    document.querySelector('.upload-entrance').style.display = 'block'
  }
  if (document.getElementById('imgCount')) {
    document.getElementById('imgCount').innerText = uploadImg.length + '/' + 4
  }
}

var deleteEvent = function() {
  this.parentNode.parentNode.removeChild(this.parentNode)
  controlImgIpt()
}
var copyText = str => {
  let selection = window.getSelection()
  let range = document.createRange()
  let $code = document.createElement('div')
  $code.display = 'none'
  $code.innerHTML = str
  document.body.appendChild($code)

  range.selectNodeContents($code)
  selection.removeAllRanges()
  selection.addRange(range)

  document.execCommand('copy')
  selection = null
  range = null
  document.body.removeChild($code)
}
if (document.querySelector('#hint p span')) {
  document.querySelector('#hint p span').addEventListener('click', () => {
    copyText('yixinlimingxiang02')
    window.toast('复制成功', 3000)
  })
}

// 绑定删除图片事件
function bindDeleteEvent() {
  ;[].forEach.call(document.querySelectorAll('.delete-img'), item => {
    item.removeEventListener('click', deleteEvent, false)
  })
  ;[].forEach.call(document.querySelectorAll('.delete-img'), item => {
    item.addEventListener('click', deleteEvent, false)
  })
  controlImgIpt()
}

// 绑定事件
function bindEvents() {
  // 选择反馈类型
  let clickEvent = function() {
    ;[].forEach.call(document.querySelectorAll('.classfy-list li'), item => {
      item.classList.remove('active')
    })
    this.classList.add('active')
  }

  ;[].forEach.call(document.querySelectorAll('.classfy-list li'), item => {
    item.addEventListener('click', clickEvent, false)
  })

  // 上传图片
  if (document.querySelector('#uploadIpt')) {
    document.querySelector('#uploadIpt').addEventListener(
      'change',
      () => {
        let $this = document.querySelector('#uploadIpt')
        var reader = new FileReader()
        let file = $this.files[0]
        var fileSize = file.size / 1024
        if (!/^image\/png|image\/gif|image\/jpeg|image\/jpg$/.test(file.type)) {
          window.toast('非法的图片格式')
          return
        }
        if (fileSize < 2 || fileSize > 5000) {
          window.toast('图片大小需在2K到5M之间')
          $this.value = ''
          return
        }
        reader.onload = e => {
          uploadImage(e.target.result)
          $this.value = ''
        }
        reader.readAsDataURL(file)
      },
      false
    )
  } else {
    ifHasUploadModule = false
  }

  // 提交
  document.querySelector('#submit').addEventListener('click', () => {
    if (isSubmiting) return
    if (!document.querySelector('.active')) {
      window.toast('请选择反馈类型哦')
      return
    }
    let type = document.querySelector('.active').dataset.type
    let content = document.getElementById('feedback').value
    let phone_number = document.getElementById('phone').value
    if (!content.length) {
      window.toast('请填写反馈内容哦')
      return
    }
    if (!phone_number.length) {
      window.toast('先填写手机号码')
      return
    }
    var images = ''
    ;[].forEach.call(document.querySelectorAll('.upload-img'), item => {
      if (images.length) {
        images = images + '|' + item.src
      } else {
        images += item.src
      }
    })
    isSubmiting = true
    let queryArgs = getQueryStringArgs()
    var formVal = queryArgs.form || ''
    $http
      .post(`${HOST}/feedback`, {
        type: type,
        content: content,
        phone_number: phone_number,
        form: formVal,
        user_id: queryArgs.userId || window.baseInfo.user_id,
        nickname: window.baseInfo.nickname,
        images: images,
        imei: queryArgs.imei,
        _platform: queryArgs._platform
      })
      .then(res => {
        isSubmiting = false
        if (res.data.code === 0) {
          window.toast(res.data.message)
          // 清空反馈的内容
          ;[].forEach.call(document.querySelectorAll('.img-con'), item => {
            item.parentNode.removeChild(item)
          })
          document.getElementById('feedback').value = ''
          document.getElementById('phone').value = ''
          ;[].forEach.call(document.querySelectorAll('.img-con'), item => {
            item.parentNode.removeChild(item)
          })
          controlImgIpt()
          setTimeout(function() {
            if (isMuseApp) {
              myBrige.call('cancelWebView')
            }
          }, 2000)
        } else {
          window.toast('提交反馈失败,失败原因:' + res.data.message)
        }
      })
  })
}

// 上传
function uploadImage(file) {
  $http
    .post(
      `${uploadHOST}/ajax/ueditor.json?action=uploadimage&type=base64`,
      qs.stringify({
        upfile: file,
        type: 'base64'
      })
    )
    .then(res => {
      console.log('上传结果：')
      console.log(res)
      renderImg(res.data.url)
    })
    .catch(err => {
      console.log('上传图片出错：')
      console.log(err)
    })
}

// 渲染图片
function renderImg(imgUrl) {
  var tempStr =
    '<div class="img-con">' +
    '<img class="upload-img" src=\'' +
    imgUrl +
    '\' alt="图片显示失败">' +
    '<button class="delete-img"></button>' +
    '</div>'
  var tempDiv = document.createElement('div')
  let $parent = document.getElementById('uploadCon')
  if ($parent.children[0]) {
    $parent.insertBefore(tempDiv, $parent.children[0])
  } else {
    $parent.appendChild(tempDiv)
  }
  tempDiv.outerHTML = tempStr
  controlImgIpt()
  bindDeleteEvent()
}

// 查询字符串参数的函数：
function getQueryStringArgs() {
  var qs = location.search.length > 0 ? location.search.substring(1) : ''
  var args = {}
  var items = qs.length ? qs.split('&') : []
  var item = null
  var name = null
  var value = null
  var i = 0
  var len = items.length
  for (; i < len; i++) {
    item = items[i].split('=')
    name = decodeURIComponent(item[0])
    value = decodeURIComponent(item[1])
    if (name.length) {
      args[name] = value
    }
  }
  return args
}

// 初始化
function init() {
  bindEvents()
}

init()



// WEBPACK FOOTER //
// ./src/pages/global/feedback/index.js